import React, { useEffect } from "react";
import PropTypes from "prop-types";
import autosize from "autosize";

const TextAutoResize = ({ autoComplete, className, onChange, placeholder, value, disabled, onKeyDown }) => {
	const textAreaRef = React.useRef(null);

	useEffect(() => {
		textAreaRef.current.focus();
		autosize(textAreaRef.current);

		if (!value) {
			// reset initial height
			textAreaRef.current.style.height = "16px";
			textAreaRef.current.style.overflow = "initial";
		}
	}, [value]);

	return (
		<React.Fragment>
			<textarea
				autoComplete={autoComplete}
				className={className}
				ref={textAreaRef}
				placeholder={placeholder}
				rows={1}
				onChange={onChange}
				value={value}
				disabled={disabled}
				onKeyDown={onKeyDown}
			/>
		</React.Fragment>
	);
};

TextAutoResize.propTypes = {
	autoComplete: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	className: PropTypes.string,
	onChange: PropTypes.func,
	placeholder: PropTypes.string,
	value: PropTypes.string,
	disabled: PropTypes.bool,
	onKeyDown: PropTypes.func,
};

export default TextAutoResize;
